import AccommodationConfirmBookingDialog from './AccommodationConfirmBookingDialog';
import { IAvailableBookingPeriod } from '@shared/integrations/taf-api/v2/models';

interface IAccommodationConfirmBookingForm {
    period?: IAvailableBookingPeriod;
    handleGetAvailablePeriods: (date: Date) => void;
    bookingGroupUrl: string;
}

const AccommodationConfirmBookingForm = ({ handleGetAvailablePeriods, period, bookingGroupUrl }: IAccommodationConfirmBookingForm) => {
    return (
        <>
            <AccommodationConfirmBookingDialog
                handleGetAvailablePeriods={handleGetAvailablePeriods}
                period={period}
                bookingGroupUrl={bookingGroupUrl}
            />
            <button
                type='button'
                className='btn btn-primary  btn-lg btn-block'
                data-toggle='modal'
                data-target='#accommondationConfirmBooking'
                disabled={!period}
            >
                Fortsätt
            </button>
        </>
    );
};
export default AccommodationConfirmBookingForm;
